module.exports = __webpack_public_path__ + "static/img/3.6a9d340.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/2/sp/3.png
// module id = AQ7V
// module chunks = 0